const moment = require("moment");

const values = [
  "open", // lead suggestion to hosts
  "interested", // lead accepted by host
  "stale", // lead has gone quiet
  "not-interested", // lead NOT accepted by host
  "not-accepted", // lead NOT accepted by organiser
  "accepted", // lead accepted by organiser and enquiry created
  "accepted-organically", // space enquired with organically for this event
  "expired", // event too close
];

const actions = {
  ACCEPT: {
    name: "accept",
    search_param: "ACCEPT",
  },
  IGNORE: {
    name: "ignore",
    search_param: "IGNORE",
  },
};

const times = {
  createIfBeforeEvent: [6, "hours"],
  makeStale: [7, "days"],
  expireBeforeEvent: [3, "hours"],
};

const status = values.reduce((acc, val) => {
  acc[val.replace(/[^a-z]/gi, "").toUpperCase()] = val;
  return acc;
}, {});

const isAfterEvent = (date) => {
  return moment()
    .add(...times.createIfBeforeEvent)
    .isAfter(moment(date));
};

module.exports = {
  actions,
  status,
  times,
  leadLimit: 35,
  maxLeadsPerEvent: 30,
  convertToEnquiryMessage:
    "Thank you for suggesting that you may be able to host my event.",
  isAfterEvent,
};
